import React from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import '../../../../../styles/components/auctions-list-modal.scss';
import { formatAmount, formatNumber } from '../../../../../utils/common';
import { Gavel, Trophy, Medal, Award } from 'lucide-react';
import i18n from '../../../../../i18n';

const rankMeta = (rank) => {
  if (!rank) {
    return { className: 'rank-none', Icon: null };
  }
  if (rank === 1) return { className: 'rank-1', Icon: Trophy };
  if (rank === 2) return { className: 'rank-2', Icon: Medal };
  if (rank === 3) return { className: 'rank-3', Icon: Award };
  return { className: 'rank-other', Icon: null };
};

export class AuctionsListModal extends React.Component {
  handleCancel = () => {
    this.props.onClose();
  };

  render() {
    const { show, auctions = [] } = this.props;
    const isArabic = i18n.language === 'ar';
    const numLocale = isArabic ? 'ar-EG-u-nu-arab' : 'en-US';
    const amountLocale = isArabic ? 'ar-OM-u-nu-arab' : 'en-US';

    return (
      <CustomModal isOpen={show} header={i18n.t('auctions_list')} onClose={this.handleCancel}>
        <div className="auctions-container">
          {auctions.length === 0 ? (
            <div className="auctions-empty">
              <Gavel size={40} strokeWidth={1.25} />
              <p>{i18n.t('no_auctions_available')}</p>
            </div>
          ) : (
            <div className="auctions-list">
              {auctions.map((auction) => {
                const { className, Icon } = rankMeta(auction.rank);
                const isPodium = auction.rank >= 1 && auction.rank <= 3;

                return (
                  <div key={auction.id} className={`auction-card${isPodium ? ' is-podium' : ''}`}>
                    <div className="auction-cover">
                      {auction.cover_image ? (
                        <img
                          src={auction.cover_image}
                          alt={auction.title}
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      ) : (
                        <div className="auction-cover-fallback">
                          <Gavel size={26} strokeWidth={1.5} />
                        </div>
                      )}
                    </div>

                    <div className="auction-body">
                      <h3 className="auction-title">
                        {isArabic ? auction.title_ar || auction.title : auction.title}
                      </h3>

                      <span className="auction-id">
                        {i18n.t('auction_id')}: {formatNumber(auction.id, numLocale)}
                      </span>

                      <div className="auction-amounts">
                        <div className="auction-amount">
                          <span className="label">{i18n.t('guarantee_amount')}</span>
                          <span className="value">
                            {formatAmount(auction.guarantee_amount, amountLocale)}
                          </span>
                        </div>

                        {auction.visit_amount ? (
                          <div className="auction-amount is-secondary">
                            <span className="label">{i18n.t('visit_amount')}</span>
                            <span className="value">
                              {formatAmount(auction.visit_amount, amountLocale)}
                            </span>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="auction-rank">
                      <span className={`rank-pill ${className}`}>
                        {Icon ? <Icon size={13} strokeWidth={2.2} /> : null}
                        {auction.rank ? (
                          <>
                            {i18n.t('rank')}
                            <span className="rank-number">
                              #{formatNumber(auction.rank, numLocale)}
                            </span>
                          </>
                        ) : (
                          i18n.t('no_bids')
                        )}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {auctions.length > 0 && (
            <div className="auctions-footer">
              <p>
                {i18n.t('total_auctions')}{' '}
                <strong>{formatNumber(auctions.length, numLocale)}</strong>
              </p>
            </div>
          )}
        </div>
      </CustomModal>
    );
  }
}
